// Promo config — single source of truth for date, price, contatti
// Scadenza: 31 luglio 2026 ore 23:59 (Europe/Rome = UTC+2 in luglio)
export const PROMO_END_ISO = '2026-07-31T23:59:00+02:00';
export const PROMO_END_DATE = new Date(PROMO_END_ISO);


export const PROMO_WHATSAPP_NUMBER = '393294007889';
export const PROMO_WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${PROMO_WHATSAPP_NUMBER}&text=${encodeURIComponent(
  'Ciao Zofia, sono interessato/a alle promo Siti Vetrina (consegna in 7 giorni).'
)}`;
export const PROMO_TEL = '+393294007889';

export const isPromoActive = () => Date.now() < PROMO_END_DATE.getTime();
